import baseURL from "../config/api";
import axios from "../config/axios";


export const post_Lesson = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}lessons?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const put_Lesson = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}lessons?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const getLessonsByCourse = (courseId: number) => {
    return getFetch(`lessons/GetLessonsByCourseId/${courseId}`);
}

export const getLessonById = (primaryKey: number) => {
    return getFetch(`lessons/${primaryKey}`);
}

export const delete_Lesson = (primaryKey: number, userId:number) => {
    return axios({
        url: `${baseURL}lessons?id=${primaryKey}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}


const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}